import React from 'react';
import DinamicScreen from '../../GeneralComponents/DinamicScreen';
import SelectReason from './SelectReason';

const Reason = () => {
  return (
    <>
      <DinamicScreen>
        <SelectReason />
      </DinamicScreen>
    </>
  )
}

export default Reason